import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=58e1556f&scoped=true"
import script from "./credit.vue?vue&type=script&lang=js"
export * from "./credit.vue?vue&type=script&lang=js"
import style0 from "./credit.vue?vue&type=style&index=0&id=58e1556f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e1556f",
  null
  
)

export default component.exports